import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const DynamicBarChart = ({ t, fetchData, transformData, title }) => {
  const [chartData, setChartData] = useState({ series: [], categories: [] });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetchData(dispatch, navigate);
        const transformed = transformData ? transformData(response.data, t) : { series: [], categories: [] };
        setChartData(transformed);
      } catch (error) {
        console.error(`Error fetching ${title} data:`, error);
      }
    };
    loadData();
  }, []);

  const options = {
    chart: { type: "bar", stacked: false },
    xaxis: { categories: chartData.categories },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        dataLabels: { position: "top" },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: () => "",
      style: { fontSize: "12px", colors: ["#ccc"] },
    },
    colors: ["#1E40AF", "#16A34A", "#DC2626", "#D97706"],
    legend: { show: true },
  };

  console.log("Chart Data:", chartData);

  return (
    <div>
      <h3>{t(title)}</h3>
      <Chart options={options} series={chartData.series} type="bar" height={300} />
    </div>
  );
};

export default DynamicBarChart;
